module.exports = __webpack_public_path__ + "mobile/img/huiTalk-img4.3fe04d43.png";